// Chrome 38 Symbol has incorrect toString conversion
module.exports = !require('../internals/fails')(function () {
  // eslint-disable-next-line no-undef
  String(Symbol());
});



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/native-symbol.js
// module id = 82
// module chunks = 1